import React from "react";
import "./Iframe.scss";

interface IframeProps {
    src: string;
    title: string;
}

const Iframe = ({ src, title }: IframeProps) => {
    return <iframe className="iframe" src={src} title={title} allowFullScreen></iframe>;
};
export default Iframe;
